
import type {ApiWorkforceProfileRecord} from '../WorkforceProfiles/workforceProfileApiTypes';

import {mapInferredCulturalAnswers} from './mapInferredCultural';
import {normalizeWorkforceProfileDetail} from './normalizeWorkforceProfileDetail';
import {ApiSerializer} from '../../../../../serializers/ApiSerializer';
import type {CompanyWorkforceProfileDetail} from '../../types/WorkforceProfileTypes';

export const mapCompanyWorkforceProfileResponse = (raw: unknown): CompanyWorkforceProfileDetail | undefined => {
  const body = ApiSerializer.toCamelCase(raw) as {companyWorkforceProfile?: ApiWorkforceProfileRecord};
  const rawBody = raw as {company_workforce_profile?: Record<string, unknown>};

  if (!body.companyWorkforceProfile) {
    return undefined;
  }

  const profile = normalizeWorkforceProfileDetail(body.companyWorkforceProfile);
  const inferredCulturalAnswers = mapInferredCulturalAnswers(
    rawBody.company_workforce_profile?.inferred_cultural_answers ?? body.companyWorkforceProfile.inferredCulturalAnswers
  );

  return {
    ...profile,
    inferredCulturalAnswers,
  };
};
